<template>
    <div>
        <Header @searchPage="init" />
        <Banner :src="src" />
        <div class="news_data">
			<h2>搜索结果</h2>
            <div v-if="!page_list.length">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <div v-else>
                <ul>
                    <li class="news_items" v-for="item in page_list" :key="item.bd_atpid">
                        <router-link :to="item.bd_contenttype=='新闻'?`/home/news/${item.bd_atpid}`:item.bd_contenttype=='产品中心'?`/product/profile/${item.bd_atpid}`:item.bd_contenttype=='解决方案'?`/solution/profile/${item.bd_atpid}`:item.bd_contenttype=='业绩报告'?`/joinDetail?detailText=${item.bd_pdfcn}`:item.bd_contenttype=='加入我们'?`/detail?detailText=${item.bd_atpid}`:item.bd_contenttype=='公司治理'?`/investor`:'javascript:;'"
                            ><span class="news_text">{{
                                item.bd_titlecn
                            }}</span></router-link
                        >
                        <router-link to="javascript:;"
                            ><span class="news_date">{{item.bd_publishdatetime}}</span></router-link
                        >
                    </li>
                </ul>
                <el-pagination background
				layout="prev, pager, next,jumper"
				:total="list_data.length"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-size="show_num">
                </el-pagination>
            </div>
		</div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Vue from 'vue'
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
export default {
    components:{Header,Banner,Footer,},
    data() {
		return {
			src: '',
			currentPage: 1,
            list_data:[],
			page_list: [],
			show_num: 5,
		}
	},
    mounted(){
        this.init(1)
		let common=JSON.parse(window.sessionStorage.getItem('commonContent'));
			for (var i = 0; i < common.length; i++) {
				if (
					common[i].sc_key.slice(0, 18) == 'SEARCHCENTERBANNER'
				) {
					this.src = common[i].sc_value
				}
			}
    },
	methods:{
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`)
			this.init(val)
		},
        init(val,data){
			this.page_list = []
			let index = (val - 1) * this.show_num
            if(data && data.length){
                this.list_data = JSON.parse(data);
            }else{
                this.list_data = JSON.parse(window.sessionStorage.getItem('data'))
            }
			for (var i = index; i < index + this.show_num; i++) {
				if(this.list_data[i]) this.page_list.push(this.list_data[i])
			}
        }
	}
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	.news_data {
		width: 1200px;
		margin: 0 auto;
		.el-pagination {
			text-align: center;
			font-weight: 400;
		}
		h2 {
			font-size: 26px;
			line-height: 100px;
		}
		ul {
			padding-bottom: 50px;
			li {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 18px;
				margin-bottom: 16px;
				border-bottom: 1px solid #ccc;
				line-height: 20px;
				padding: 8px 0;
				background: url(~@/assets/imgs/right.png) no-repeat left center;
				padding-left: 20px;
				.news_text {
					width: 750px;
					display: inline-block;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					transition: all 0.4s ease;
				}
				.news_date {
					color: #999;
				}
			}
			li:hover {
				a {
					text-decoration: none;
				}
			}
			li .news_text:hover {
				color: royalblue;
				transform: translate(5px);
			}
		}
	}
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	.news_data {
		padding: 0 rm(20) rm(20);
		.el-pagination {
			text-align: right;
			display: none;
		}
		h2 {
			font-size: rm(26);
			line-height: rm(100);
		}
		ul {
			padding-bottom: rm(150);
			li {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: rm(18);
				margin-bottom: rm(20);
				padding: rm(8) 0;
				background: url(~@/assets/imgs/right.png) no-repeat left center;
				padding-left: rm(28);
				.news_text {
					width: rm(180);
					display: inline-block;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					transition: all 0.4s ease;
					color: #333;
				}
				.news_date {
					color: #999;
				}
			}
			li:hover {
				a {
					text-decoration: none;
				}
			}
			li .news_text:hover {
				color: royalblue;
				transform: translate(5px);
			}
		}
	}
}
</style>